import { ITheme } from "../../utils/theme";

export const iconStyle = {
  height: "32px",
  width: "32px",
  color: "grey"
};

export const nameCardStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: (theme: ITheme) => theme.palette.primary.main,
  padding: 1
};

export const nameCardAvatarStyle = {
  width: 128,
  height: 128,
  marginBottom: 1
};

export const securityCardStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 1
}

export const securityCardRowStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};

export const myProfileStyle = {
  padding: 1,
  display: "flex",
  flexDirection: "column",
  gap: 1
}
